module.exports = __webpack_public_path__ + "img/extensionAndAgent.691a5678.svg";